import Config from '../utils/Config.js';
import ButtonManager from '../utils/ButtonsManager';

export default class StateButton extends Phaser.Button {

    constructor(game, x, y, key, handler, handlerContext)
    {
        super(game, x, y, key);

        this.hitArea = this._getHitArea(new Phaser.Image(game, 0, 0, key, 0));
        this.enabled = true;

        ButtonManager.register(this);

        this.onInputUp.add((target, pointer) =>
        {
            if (!Phaser.Rectangle.containsPoint(this.getBounds(), pointer.position))
            {
                return;
            }

            if (typeof handler !== 'function')
            {
                return;
            }

           try
           {
               handler.call(handlerContext || this, this, pointer, this.isOver);
           }
           catch(e)
           {
               console.warn('Click callback execution error:', e.message);
           }
        });
    }

    _getHitArea(image)
    {
        let bd = new Phaser.BitmapData(this.game, '', image.width, image.height);
        bd.draw(image, 0, 0, bd.width, bd.height, null, true);
        bd.update();
        return bd.getBounds();
    }

    get enabled()
    {
        return this.inputEnabled;
    }

    set enabled(value)
    {
        this.inputEnabled = value;
        this.alpha = value ? 1 : 0.5;
        if (Config.MobileDevice)
        {
            value ? this.setFrames(0, 0, 1, 0) : this.setFrames(1, 1, 1, 1);
        }
        else
        {
            value ? this.setFrames(2, 0, 1, 0) : this.setFrames(1, 1, 1, 1);
        }
    }

    destroy()
    {
        ButtonManager.unregister(this);
        super.destroy();
    }
}